import * as React from "react";
import { cn } from "@/lib/utils";

const TableToolbar = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            "border-b border-table-border bg-table-toolbar p-3 space-y-2",
            className,
        )}
        {...props}
    />
));
TableToolbar.displayName = "TableToolbar";

export { TableToolbar };
